import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Product } from '../../../models/product.model';
import { ProductFlag } from '../../../enums/product-flag';
import { isEmptyArray } from '../../../shared/utils';

@Component({
  selector: 'app-product-flag-container',
  templateUrl: './product-flag-container.component.html',
  styleUrls: ['./product-flag-container.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ProductFlagContainerComponent {
  @Input() product: Product;

  get productFlags(): ProductFlag[] {
    if (isEmptyArray(this.product?.small_flags)) {
      return [];
    }

    return this.product.small_flags;
  }
}
